import { useState } from 'react'

const ACOES = {
  ENVIO_EMAIL_COLOG: '001 - Envio da Programação Por Email - COLOG',
  EXPORT_EXCEL_PROGRAMACAO: '002 - Exportar Programação 1º Trecho - Excel',
  REVISAO_PROGRAMACAO_CARGA: '003 - Revisão da Data de Progr. de Receb. de Carga',
  PLACAS_PREVISTA_CARREGAMENTO: '004 - Placas Previstas Para Carregamento',
  ALTERACAO_QTE: '005 - Alteração de Quantidade',
  ESPELHO_ENTREGAS: '006 - Espelho de Entregas',
  GERAR_CROSS_RECEBIMENTO: '007 - Gerar Ciclo Cross-Recebimento',
  ASSOCIAR_XMLS: '008 - Associar XMLs',
  BAIXAR_CANHOTOS: '009 - Baixar Canhotos',
  ENTRADA_SIF: '010 - Entrada SIF',
  MAPA_PESO_CIDADE: '011 - Exportar Mapa de Peso por Cidade',
  ETIQUETAGEM_VOLUMES: '012 - Etiquetagem de Volumes',
}
export const TIPOS_ACOES_CICLO_ENTREGA = [
  { value: ACOES.ENVIO_EMAIL_COLOG, label: ACOES.ENVIO_EMAIL_COLOG },
  { value: ACOES.EXPORT_EXCEL_PROGRAMACAO, label: ACOES.EXPORT_EXCEL_PROGRAMACAO },
  { value: ACOES.REVISAO_PROGRAMACAO_CARGA, label: ACOES.REVISAO_PROGRAMACAO_CARGA },
  { value: ACOES.PLACAS_PREVISTA_CARREGAMENTO, label: ACOES.PLACAS_PREVISTA_CARREGAMENTO },
  { value: ACOES.ALTERACAO_QTE, label: ACOES.ALTERACAO_QTE },
  { value: ACOES.ESPELHO_ENTREGAS, label: ACOES.ESPELHO_ENTREGAS },
  { value: ACOES.GERAR_CROSS_RECEBIMENTO, label: ACOES.GERAR_CROSS_RECEBIMENTO },
  { value: ACOES.ASSOCIAR_XMLS, label: ACOES.ASSOCIAR_XMLS },
  { value: ACOES.BAIXAR_CANHOTOS, label: ACOES.BAIXAR_CANHOTOS },
  { value: ACOES.ENTRADA_SIF, label: ACOES.ENTRADA_SIF },
  { value: ACOES.MAPA_PESO_CIDADE, label: ACOES.MAPA_PESO_CIDADE },
  { value: ACOES.ETIQUETAGEM_VOLUMES, label: ACOES.ETIQUETAGEM_VOLUMES },
]

export const ACAO_TELA_SELECIONADA = {
  ENVIO_EMAIL: 'ENVIO_EMAIL',
  EXPORT_EXCEL_PROGRAMACAO: 'EXPORT_EXCEL_PROGRAMACAO',
  REVISAO_PROGRAMACAO_CARGA: 'REVISAO_PROGRAMACAO_CARGA',
  PLACA_PREVISAO_CARREGAMENTO: 'PLACA_PREVISAO_CARREGAMENTO',
  ALTERACAO_QTE: 'ALTERACAO_QTE',
  ESPELHO_ENTREGAS: 'ESPELHO_ENTREGAS',
  GERAR_CROSS_RECEBIMENTO: 'GERAR_CROSS_RECEBIMENTO',
  ASSOCIAR_XMLS: 'ASSOCIAR_XMLS',
  BAIXAR_CANHOTOS: 'BAIXAR_CANHOTOS',
  ENTRADA_SIF: 'ENTRADA_SIF',
  MAPA_PESO_CIDADE: 'MAPA_PESO_CIDADE',
  ETIQUETAGEM_VOLUMES: 'ETIQUETAGEM_VOLUMES',
  NONE: 'NONE',
}

export default function useCicloEntregaAcoesState(cicloEntrega) {
  const [acaoSelecionada, setAcaoSelecionada] = useState('')
  const [telaSelecionada, setTelaSelecionada] = useState(ACAO_TELA_SELECIONADA.NONE)

  // Events
  function onDropdownChange(option) {
    if (option === ACOES.ENVIO_EMAIL_COLOG) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ENVIO_EMAIL)
    } else if (option === ACOES.EXPORT_EXCEL_PROGRAMACAO) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.EXPORT_EXCEL_PROGRAMACAO)
    } else if (option === ACOES.REVISAO_PROGRAMACAO_CARGA) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.REVISAO_PROGRAMACAO_CARGA)
    } else if (option === ACOES.PLACAS_PREVISTA_CARREGAMENTO) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.PLACA_PREVISAO_CARREGAMENTO)
    } else if (option === ACOES.ALTERACAO_QTE) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ALTERACAO_QTE)
    } else if (option === ACOES.ESPELHO_ENTREGAS) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ESPELHO_ENTREGAS)
    } else if (option === ACOES.GERAR_CROSS_RECEBIMENTO) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.GERAR_CROSS_RECEBIMENTO)
    } else if (option === ACOES.ASSOCIAR_XMLS) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ASSOCIAR_XMLS)
    } else if (option === ACOES.BAIXAR_CANHOTOS) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.BAIXAR_CANHOTOS)
    } else if (option === ACOES.ENTRADA_SIF) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ENTRADA_SIF)
    } else if (option === ACOES.MAPA_PESO_CIDADE) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.MAPA_PESO_CIDADE)
    } else if (option === ACOES.ETIQUETAGEM_VOLUMES) {
      setTelaSelecionada(ACAO_TELA_SELECIONADA.ETIQUETAGEM_VOLUMES)
    }
    setAcaoSelecionada(option)
  }

  return {
    acaoSelecionada,
    telaSelecionada,
    onDropdownChange,
  }
}
